import { Link } from "react-router-dom";
import PageWithAds from "../components/PageWithAds";

function SavnotAbout() {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#000',
      color: '#fff',
      padding: '0',
      margin: '0',
    }}>
      {/* Header */}
      <div style={{
        textAlign: 'center',
        padding: '60px 20px 40px',
      }}>
        <img 
          src="/logo/logo.png" 
          alt="SavNot Logo" 
          style={{
            width: '120px',
            height: '120px',
            marginBottom: '16px',
          }}
        />
        <h1 style={{
          fontSize: '36px',
          fontWeight: '800',
          color: '#114232',
          marginBottom: '12px',
        }}>
          SavNot
        </h1>
        <p style={{
          fontSize: '18px',
          fontWeight: '300',
          color: '#ccc',
          textAlign: 'center',
        }}>
          Düşüncelerinize değer verin. Kargaşadan uzak, özgürce paylaşın.
        </p>
      </div>

      {/* Content */}
      <div style={{
        maxWidth: '900px',
        margin: '0 auto',
        padding: '20px',
      }}>
        {/* SavNot Nedir */}
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#114232',
            marginBottom: '12px',
          }}>
            🎯 SavNot Nedir?
          </h2>
          <p style={{
            fontSize: '16px',
            lineHeight: '24px',
            color: '#ccc',
          }}>
            SavNot, düşüncelerinizi değerle paylaştığınız, kargaşadan uzak bir sosyal platformdur. 
            Her gün sadece bir paylaşım hakkınız olduğu için her sözünüz anlamlı ve düşünülmüş olur.
          </p>
        </div>

        {/* Neler Yapabilirsiniz */}
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#114232',
            marginBottom: '12px',
          }}>
            ✨ Neler Yapabilirsiniz?
          </h2>
          
          <div style={{
            backgroundColor: 'rgba(17, 66, 50, 0.1)',
            border: '2px solid #114232',
            borderRadius: '12px',
            padding: '20px',
            marginBottom: '12px',
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#1a5a42',
              marginBottom: '8px',
            }}>
              📝 Günde Bir Paylaşım
            </h3>
            <p style={{
              fontSize: '15px',
              color: '#ccc',
              lineHeight: '22px',
            }}>
              24 saatte bir kez düşüncenizi, deneyiminizi veya fikrini özgürce paylaş. 
              Bu sınır sayesinde her paylaşımın değeri artar.
            </p>
          </div>

          <div style={{
            backgroundColor: 'rgba(17, 66, 50, 0.1)',
            border: '2px solid #114232',
            borderRadius: '12px',
            padding: '20px',
            marginBottom: '12px',
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#1a5a42',
              marginBottom: '8px',
            }}>
              💫 Keşfet & Etkileş
            </h3>
            <p style={{
              fontSize: '15px',
              color: '#ccc',
              lineHeight: '22px',
            }}>
              Diğer kullanıcıların kaliteli içeriklerini keşfet, beğen ve yorum yap. 
              Takip ettiğin kişilerden anlık bildirim al.
            </p>
          </div>

          <div style={{
            backgroundColor: 'rgba(17, 66, 50, 0.1)',
            border: '2px solid #114232',
            borderRadius: '12px',
            padding: '20px',
            marginBottom: '12px',
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#1a5a42',
              marginBottom: '8px',
            }}>
              🏆 SavLike'ta Yarış
            </h3>
            <p style={{
              fontSize: '15px',
              color: '#ccc',
              lineHeight: '22px',
            }}>
              Her gün sıfırlanan liderlik sıralamasında puan kazan. En çok beğeni 
              ve yorumu alan içerikler zirvede parlıyor!
            </p>
          </div>

          <div style={{
            backgroundColor: 'rgba(17, 66, 50, 0.1)',
            border: '2px solid #114232',
            borderRadius: '12px',
            padding: '20px',
            marginBottom: '12px',
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#1a5a42',
              marginBottom: '8px',
            }}>
              ⚔️ SavWar'da Savaş
            </h3>
            <p style={{
              fontSize: '15px',
              color: '#ccc',
              lineHeight: '22px',
            }}>
              Belirli konular hakkında 24 saatlik özel yarışmalarda katıl. 
              Kazandığın TP puanlarıyla rütben yükselsin!
            </p>
          </div>
        </div>

        {/* Amacımız */}
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#114232',
            marginBottom: '12px',
          }}>
            💎 Amacımız
          </h2>
          <p style={{
            fontSize: '18px',
            color: '#1a5a42',
            fontWeight: '700',
            textAlign: 'center',
            marginBottom: '16px',
            fontStyle: 'italic',
          }}>
            "Kaliteli içeriği ödüllendiren, spam-free bir topluluk yaratmak"
          </p>
          <p style={{
            fontSize: '16px',
            color: '#ccc',
            lineHeight: '24px',
          }}>
            Sosyal medyadaki karmaşadan ve anlık tepkilerden sıyrılarak, her sözün 
            değerli olduğu saygılı bir ortam sunuyoruz. Burada herkes dikkatle 
            düşünür, özgürce paylaşır.
          </p>
        </div>

        {/* SavLike Sistemi */}
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#114232',
            marginBottom: '12px',
          }}>
            ⭐ SavLike - Günlük Liderlik
          </h2>
          <p style={{
            fontSize: '16px',
            lineHeight: '24px',
            color: '#ccc',
            marginBottom: '12px',
          }}>
            Her gün 00:00'da sıfırlanan dinamik liderlik sistemi. Postlarınız aldığı 
            beğeni ve yorumlarla puan kazanıp sıralamada yükseliyorsunuz.
          </p>
          
          <div style={{
            backgroundColor: 'rgba(17, 66, 50, 0.1)',
            border: '2px solid #114232',
            borderRadius: '12px',
            padding: '20px',
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#1a5a42',
              marginBottom: '8px',
            }}>
              🏆 Nasıl Çalışır?
            </h3>
            <p style={{
              fontSize: '15px',
              color: '#ccc',
              lineHeight: '22px',
            }}>
              • <span style={{ color: '#1a5a42', fontWeight: '700' }}>Puan:</span> Beğeni × 1 + Yorum × 0.2<br/>
              • <span style={{ color: '#1a5a42', fontWeight: '700' }}>🥇 1. Sıra:</span> Altın çerçeve<br/>
              • <span style={{ color: '#1a5a42', fontWeight: '700' }}>🥈 2. Sıra:</span> Gümüş çerçeve<br/>
              • <span style={{ color: '#1a5a42', fontWeight: '700' }}>🥉 3. Sıra:</span> Bronz çerçeve<br/>
              • İlk 100 post görüntülenir, anlık güncelleme
            </p>
          </div>
        </div>

        {/* SavWar Sistemi */}
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#114232',
            marginBottom: '12px',
          }}>
            ⚔️ SavWar - Kelime Savaşları
          </h2>
          <p style={{
            fontSize: '16px',
            lineHeight: '24px',
            color: '#ccc',
            marginBottom: '12px',
          }}>
            Belirli hashtag temasında 24 saatlik özel yarışlar. Admin'in belirlediği 
            #kelime ile ilgili en iyi postu yazan TP puanı kazanıyor!
          </p>
          
          <div style={{
            backgroundColor: 'rgba(17, 66, 50, 0.1)',
            border: '2px solid #114232',
            borderRadius: '12px',
            padding: '20px',
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#1a5a42',
              marginBottom: '8px',
            }}>
              🎖️ TP Sistemi & Rütbeler
            </h3>
            <p style={{
              fontSize: '15px',
              color: '#ccc',
              lineHeight: '22px',
            }}>
              • <span style={{ color: '#1a5a42', fontWeight: '700' }}>TP Kazanma:</span> 1. sıra +20, 2. sıra +10, 3. sıra +5<br/>
              • <span style={{ color: '#1a5a42', fontWeight: '700' }}>Rütbe Yükseltme:</span> 0 TP'den Mareşal'e kadar<br/>
              • <span style={{ color: '#1a5a42', fontWeight: '700' }}>Kalıcı Puan:</span> TP puanları asla sıfırlanmaz<br/>
              • Her beğeni +0.2 TP, her yorum +0.1 TP
            </p>
          </div>
        </div>

        {/* Gelecek Özellikler */}
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#114232',
            marginBottom: '12px',
          }}>
            🚀 Yakında Gelenler
          </h2>
          <p style={{
            fontSize: '16px',
            color: '#ccc',
            lineHeight: '24px',
          }}>
            • 📱 <span style={{ color: '#1a5a42', fontWeight: '700' }}>iOS & Android Apps</span> - Native mobil deneyim<br/>
            • 🎨 <span style={{ color: '#1a5a42', fontWeight: '700' }}>Tema Seçenekleri</span> - Karanlık/Aydınlık mod<br/>
            • 📊 <span style={{ color: '#1a5a42', fontWeight: '700' }}>Hikaye & Anketler</span> - Kısa süreli paylaşımlar<br/>
            • 🎭 <span style={{ color: '#1a5a42', fontWeight: '700' }}>Topluluk Grupları</span> - Özel ilgi alanları<br/>
            • 🎬 <span style={{ color: '#1a5a42', fontWeight: '700' }}>Video & Ses</span> - Zengin medya desteği<br/>
            • 🤖 <span style={{ color: '#1a5a42', fontWeight: '700' }}>AI Öneriler</span> - Kişiselleştirilmiş içerik
          </p>
        </div>

        {/* İletişim */}
        <div style={{
          backgroundColor: 'rgba(17, 66, 50, 0.1)',
          border: '2px solid #114232',
          borderRadius: '12px',
          padding: '24px',
          marginBottom: '32px',
        }}>
          <h2 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#114232',
            marginBottom: '12px',
          }}>
            📬 İletişim
          </h2>
          <p style={{
            fontSize: '16px',
            color: '#ccc',
            lineHeight: '28px',
            marginBottom: '8px',
          }}>
            <span style={{ color: '#1a5a42', fontWeight: '700' }}>E-posta:</span> info@savnot.com
          </p>
          <p style={{
            fontSize: '16px',
            color: '#ccc',
            lineHeight: '28px',
            marginBottom: '8px',
          }}>
            <span style={{ color: '#1a5a42', fontWeight: '700' }}>Adres:</span> Antalya, Türkiye
          </p>
          <p style={{
            fontSize: '14px',
            color: '#888',
            lineHeight: '22px',
            marginTop: '16px',
          }}>
            Sorularınız, önerileriniz veya geri bildirimleriniz için bizimle iletişime geçmekten çekinmeyin. 
            SavNot topluluğunun bir parçası olduğunuz için teşekkür ederiz!
          </p>
        </div>

        {/* Hemen Katıl Butonu */}
        <div style={{
          textAlign: 'center',
          marginTop: '32px',
          marginBottom: '32px',
        }}>
          <Link 
            to="/register"
            style={{
              display: 'inline-block',
              backgroundColor: '#114232',
              color: '#fff',
              padding: '16px 48px',
              borderRadius: '12px',
              fontSize: '18px',
              fontWeight: '600',
              textDecoration: 'none',
              transition: 'all 0.3s ease',
              border: '2px solid #114232',
            }}
          >
            Hemen Katıl
          </Link>
        </div>
      </div>

      {/* Footer */}
      <div style={{
        marginTop: '48px',
        paddingTop: '24px',
        borderTop: '1px solid rgba(17, 66, 50, 0.3)',
        textAlign: 'center',
        padding: '24px 20px',
      }}>
        <p style={{
          fontSize: '14px',
          color: '#666',
          textAlign: 'center',
          marginBottom: '8px',
        }}>
          © 2025 SavNot. Tüm hakları saklıdır.
        </p>
        <Link 
          to="/terms" 
          style={{
            fontSize: '13px',
            color: '#888',
            textDecoration: 'none',
            display: 'block',
            marginBottom: '8px',
          }}
          onMouseOver={(e) => e.currentTarget.style.color = '#114232'}
          onMouseOut={(e) => e.currentTarget.style.color = '#888'}
        >
          📜 Kullanıcı Sözleşmesi
        </Link>
        <p style={{
          fontSize: '13px',
          color: '#666',
          textAlign: 'center',
        }}>
          Düşüncelerinize değer verin. Kargaşadan uzak, özgürce paylaşın.
        </p>
      </div>
    </div>
  );
}

export default function SavnotAboutWithAds() {
  return (
    <PageWithAds leftAdSlot="2827726931" rightAdSlot="2193920119">
      <SavnotAbout />
    </PageWithAds>
  );
}
